export const checkPresent = <T>(value: T, message = 'Value must be present'): T => {
    if (value === null || value === undefined) {
        throw new Error(message);
    }
    return value;
};
